import { useEffect, useRef, useState } from "react";
import * as React from "react";
import { useReactToPrint } from "react-to-print";
import HtmlDo from "./HtmlDo";

import ModalPosPrintout from "../popups/ModalPosPrintout";
import ModalGalPrintout from "../popups/ModalGalPrintout";
import ModalHSlidePrintout from "../popups/ModalHSlidePrintout";
import ModalMSlidePrintout from "../popups/ModalMSlidePrintout";
//import ModalFaqPrintout from "../popups/ModalFaqPrintout";
//ModalPosPrintout, ModalGalPrintout, ModalHSlidePrintout, ModalMSlidePrintout
import ModalFaqPrintout from "../popups/ModalFaqPrintout";
import ModalCatPrintout from "../popups/ModalCatPrintout";
import ModalPagPrintout from "../popups/ModalPagPrintout";


import ModalStaffIDCard from "../popups/ModalStaffIDCard";
import ModalBulkStaffIDCard from "../popups/ModalBulkStaffIDCard";


const PrintDoc = (props) => {
  const [referenceNo, setReferenceNo] = useState("");
  const [itemIds, setItemIds] = useState([]);
  const [docTypes, setDocTypes] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    setReferenceNo(props.referenceNo);
    setItemIds(props.id);
    setDocTypes(props.docType);
    setTitle(props.title);
  }, [
    props.referenceNo,
    props.id,
    props.docType,
    props.datesUseds,
    props.pdfPrints,
    props.title,
  ]);

  const componentRef = useRef(null);
  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    return Promise.resolve();
  }, []);

  const reactToPrintFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: title,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  let tagName;
  switch (docTypes) {
    //ModalPosPrintout, ModalGalPrintout, ModalHSlidePrintout, ModalMSlidePrintout
    case "ModalPosPrintout":
      tagName = (
        <ModalPosPrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;
      case "ModalGalPrintout":
      tagName = (
        <ModalGalPrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;
      case "ModalHSlidePrintout":
      tagName = (
        <ModalHSlidePrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;
      case "ModalMSlidePrintout":
      tagName = (
        <ModalMSlidePrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;
      // case "ModalFaqPrintout":
      // tagName = (
      //   <ModalFaqPrintout
      //     itemId={props.id}
      //     direction={"2"}
      //     datesUsed={props.datesUseds}
      //     pdfPrint={false}
      //     referenceNo={referenceNo}
      //   />
      // );
      // break;




    case "ModalFaqPrintout":
      tagName = (
        <ModalFaqPrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;
      case "ModalCatPrintout":
      tagName = (
        <ModalCatPrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;

      case "ModalPagPrintout":
      tagName = (
        <ModalPagPrintout
          itemId={props.id}
          direction={"2"}
          datesUsed={props.datesUseds}
          pdfPrint={false}
          referenceNo={referenceNo}
        />
      );
      break;


    /////////////////////////////////////////////////////////////

    case "HtmlDo":
      tagName = <HtmlDo />;
      break;
    
    case "ModalStaffIDCard":
      tagName = (
        <ModalStaffIDCard
          itemId={props.id}
          direction={"2"}
          referenceNo={referenceNo}
        />
      );
      break;
    case "ModalBulkStaffIDCard":
      tagName = (
        <ModalBulkStaffIDCard
          itemId={props.id}
          direction={"2"}
          referenceNo={referenceNo}
        />
      );
      break;

    default:
      tagName = <ModalStaffIDCard itemId={itemIds} direction={"2"} />;
  }

  return (
    <div>
      <button
        onClick={reactToPrintFn}
        className="btn btn-primary col-lg-3 mt-4 mb-4"
      >
        Print Document <i className="fa fa-print pt-1 pe-2"></i>
      </button>

      <div ref={componentRef}>{tagName}</div>
    </div>
  );
};

export default PrintDoc;
